<template>
  <main class="main configurations">
    <div class="white-panel">
      <header class="panel-header">
        <router-link
          :to="{ name: 'ServiceSettingsPage', params: { serviceID: serviceID } }"
          type="button"
          class="step-back"
          :aria-label="$t('step.back')"
          :title="$t('step.back')"
        />
        <h2 class="panel-title">
          {{ $t('operators.management') }}
        </h2>
      </header>

      <!-- Users -->
      <div
        class="system-users-list panel-scroll"
      >
        <div
          v-for="user in users"
          id="system-user-1"
          :key="user.username"
          class="row row-small space-between system-user"
        >
          <div class="user-data flex-center">
            <div class="avatar">
              <img
                :src="`https://fenix.tecnico.ulisboa.pt/user/photo/${user.id}`"
                alt=""
              >
            </div>
            <div class="user-info">
              <div class="label-primary">
                {{ user.name }} <span>{{ user.id }}</span>
              </div>
            </div>
          </div>
          <div class="actions">
            <button
              type="button"
              class="btn-delete btn-tooltip link-modal"
              :data-tooltip="$t('erase')"
              :aria-label="$t('erase')"
              @click="openDeleteOperatorModal({ user })"
            />
          </div>
        </div>

        <!-- Criar utilizador -->
        <div class="row row-small">
          <button
            type="button"
            class="btn-add-new link-modal"
            aria-haspopup="true"
            aria-expanded="false"
            @click="openCreateOperatorModal()"
          >
            {{ $t('create.user') }}...
          </button>
        </div>
      </div>
    </div>
    <modal v-model="createOperatorModal">
      <create-operator
        slot="modal-panel"
        v-model="createOperatorModal"
        :service-i-d="serviceID"
      />
    </modal>
    <modal v-model="deleteOperatorModal">
      <delete-operator
        slot="modal-panel"
        v-model="deleteOperatorModal"
        :user="workingUser"
        :service-i-d="serviceID"
      />
    </modal>
  </main>
</template>
<script>
import CreateOperator from '@/components/modals/CreateOperator'
import DeleteOperator from '@/components/modals/DeleteOperator'
import Modal from '@/components/utils/Modal'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    CreateOperator,
    DeleteOperator,
    Modal
  },
  props: {
    serviceID: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      createOperatorModal: false,
      deleteOperatorModal: false,
      workingUser: undefined
    }
  },
  computed: {
    ...mapState(['users'])
  },
  created () {
    this.fetchUsers({ service: this.serviceID, type: 'operator' })
  },
  methods: {
    ...mapActions(['fetchUsers']),
    async openCreateOperatorModal () {
      this.createOperatorModal = true
    },
    async openDeleteOperatorModal ({ user }) {
      this.workingUser = user
      this.deleteOperatorModal = true
    }
  }
}
</script>
